// extracted by mini-css-extract-plugin
export default {"largo":"SignUp_largo__RpbJf","errorMsj":"SignUp_errorMsj__QAAGr"};